import { useCallback, useEffect, useState } from 'react';

import CaxyLightstream, { EpicData } from 'services/caxyLightstream';

const INITIAL_DATA = { y: 0, MARKET: {} };

/**
 * Maintains a connection to the IG public forex data server
 * @param epicNames (optional) - if given, only the listed epic names will be subscribed to
 */
const useCaxyLightstream = (epicNames?: string[]) => {
  const [conn, setConn] = useState<CaxyLightstream | null>(null);
  const [data, setData] = useState<EpicData>(INITIAL_DATA);

  const handleDataChange = useCallback(
    (newData: EpicData) => {
      //we need to make a copy of newData- CaxyLightstream maintains a single stable object
      //that won't trigger react renders
      setData({ y: newData.y, MARKET: { ...newData.MARKET } });
    },
    [setData]
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      //prevent trying to connect to the server when compiling under SSR
      return;
    }

    try {
      const lightstream = new CaxyLightstream('upp.ig.com');
      setConn(lightstream);
      lightstream.registerCallback(handleDataChange);
      lightstream.connectWebsocket().then(() => {
        //subscribing to all saves the caller from needing to sort out the huge list
        //of currencies. It's also how the IG prod site works
        if (!epicNames || !epicNames.length) {
          lightstream.subscribeAll();
        } else {
          lightstream.subscribeList(epicNames);
        }
      });
    } catch (ex) {
      console.warn('failed lightstream: ', ex);
    }

    return () => {
      conn?.disconnect();
      setConn(null);
    };
  }, []);

  return { lightstream: conn, data };
};

export default useCaxyLightstream;
